import { render, staticRenderFns } from "./EditorNavBar.vue?vue&type=template&id=6587f76a&scoped=true"
import script from "./EditorNavBar.vue?vue&type=script&lang=js"
export * from "./EditorNavBar.vue?vue&type=script&lang=js"
import style0 from "./EditorNavBar.vue?vue&type=style&index=0&id=6587f76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587f76a",
  null
  
)

export default component.exports